import type { StartProgress } from "../progress/start-progress";

const seedViewerName = "maxwell";
const seedPlayerId = "ply_2f0c9f3a-0d41-4d0c-9a7a-1b2f3c4d5e6f";
const seedPlayerName = "softmaxwell";
const seedAvatarUrl =
  "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><rect width='20' height='20' fill='%23161616'/><path d='M4 15c1.6-3 10.4-3 12 0M10 4a3 3 0 100 6 3 3 0 000-6' fill='none' stroke='%23fffdf4' stroke-width='1.4'/></svg>";
const seedAgentName = "softmax-cli";
const seedPolicyName = "greedy-expansion-baseline";
const seedPolicyVersion = 1;
const seedPolicyFileBytes = 36_864;
const seedRequestId = "7c1f2a90-4b6e-4d21-9f33-2a51c0de77ab";
const seedSubmissionId = "sub_5d81b0ac-3f2e-4a17-8c9b-6e0d2f7a3145";

export function seedProgressForStage(stage: number): StartProgress {
  return {
    signedIn: stage >= 1,
    linked: stage >= 3,
    uploaded: stage >= 4,
    seated: stage >= 7,
    viewerName: stage >= 1 ? seedViewerName : null,
    player:
      stage >= 2
        ? {
            id: seedPlayerId,
            name: seedPlayerName,
            avatarUrl: seedAvatarUrl,
          }
        : null,
    agentName: stage >= 3 ? seedAgentName : null,
    policyName: stage >= 4 ? seedPolicyName : null,
    policyVersion: stage >= 4 ? seedPolicyVersion : null,
    ...seedPolicyActivity(stage),
    checkedAt: new Date().toISOString(),
  };
}

function seedPolicyActivity(
  stage: number,
): Pick<
  StartProgress,
  "policyArtifact" | "experienceRequest" | "leagueSubmission"
> {
  return {
    policyArtifact:
      stage >= 4
        ? { files: 1, sizeBytes: seedPolicyFileBytes, kind: "player-file" }
        : null,
    experienceRequest:
      stage >= 5
        ? {
            id: seedRequestId,
            status: stage >= 7 ? "completed" : "running",
            episodes: 20,
            completed: stage >= 7 ? 20 : 8,
            failed: 0,
          }
        : null,
    leagueSubmission:
      stage >= 6
        ? { id: seedSubmissionId, status: stage >= 7 ? "placed" : "pending" }
        : null,
  };
}
